import { AppState, FeedPageBangkokAppState } from '../../../initialStateRegistration';
import { FeedPageBangkokMinorSections, FeedPageSectionNames, FeedPageBangkokTopSection } from './feedPageBangkok.initialState';
import { getHomePage } from '../../homePage/homePageDubai/homePageDubai.selectors';

export const getFeedPage = (state: AppState) => (state as FeedPageBangkokAppState).template;

export const getSectionDataByKey = (key: FeedPageSectionNames) => (state: AppState) => getFeedPage(state)[key];

export const getSectionArticlesByKey = (key: FeedPageSectionNames) => (state: AppState) => getFeedPage(state)[key].articles;

export const getSectionTitleByKey = (key: FeedPageSectionNames) => (state: AppState) => getFeedPage(state)[key].sectionTitle;

export const getSectionSubtitleByKey = (key: FeedPageBangkokTopSection) => (state: AppState) => getFeedPage(state)[key].sectionSubtitle;

export const getShowMorePaginationTextByKey = (key: FeedPageBangkokMinorSections) => (state: AppState) => getFeedPage(state)[key].showMorePaginationText;

export const getShowMorePaginationURLByKey = (key: FeedPageBangkokMinorSections) => (state: AppState) => getFeedPage(state)[key].showMorePaginationURL;

export const getMetadataDescription = (state: AppState) => getFeedPage(state).metadataDescription;

export const getMetadataTitle = (state: AppState) => getFeedPage(state).metadataTitle;

export const getMetadataAdsCategory = (state: AppState) => getFeedPage(state).metadataAdsCategory;

export const getMetadataImage = (state: AppState) => getHomePage(state).metadataImage;
